export default __webpack_public_path__ + "static/media/clipboard.b967d5ee.svg";